module.exports = __webpack_public_path__ + "static/media/bezTeksta.19e40f95.png";